import { render, staticRenderFns } from "./WinnerMatchCoefHighlight.vue?vue&type=template&id=28a860a6&scoped=true&"
import script from "./WinnerMatchCoefHighlight.vue?vue&type=script&lang=js&"
export * from "./WinnerMatchCoefHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a860a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
